import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { tokenStore } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    if (!tokenStore.access) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
    const onLogout = () => setUser(null);
    window.addEventListener("th-logout", onLogout);
    return () => window.removeEventListener("th-logout", onLogout);
  }, [loadMe]);

  const requestOtp = async (phone) => {
    const { data } = await api.post("/auth/otp/request", { phone });
    return data;
  };

  const verifyOtp = async (phone, code, name, acceptPrivacy = false) => {
    const ref = localStorage.getItem("th_ref") || undefined;
    const { data } = await api.post("/auth/otp/verify", { phone, code, name, accept_privacy: acceptPrivacy, ref });
    localStorage.removeItem("th_ref");
    tokenStore.set(data.access_token, data.refresh_token);
    setUser(data.user);
    return data.user;
  };

  const updateProfile = async (updates) => {
    const { data } = await api.put("/auth/profile", updates);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      if (tokenStore.refresh) await api.post("/auth/logout", { refresh_token: tokenStore.refresh });
    } catch (e) {
      /* ignore */
    }
    tokenStore.clear();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, requestOtp, verifyOtp, updateProfile, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
